// eslint-disable-next-line import/no-extraneous-dependencies
import * as React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.07}
    height={17.07}
    className={className}
  >
    <path
      d="M9.389 5.975a.854.854 0 1 0-1.707 0v2.561a.853.853 0 0 0 .25.6l1.707 1.707a.853.853 0 0 0 1.207-1.207L9.389 8.179Zm-.853-4.268A7.681 7.681 0 1 1 .854 9.389a7.681 7.681 0 0 1 7.681-7.682Zm0 1.707a5.974 5.974 0 1 0 5.974 5.974 5.974 5.974 0 0 0-5.975-5.974ZM13.052.25a.853.853 0 0 1 1.207 0l2.561 2.56a.853.853 0 0 1-1.207 1.207l-2.56-2.56A.853.853 0 0 1 13.052.25Zm-9.035 0a.853.853 0 0 1 0 1.207l-2.56 2.56A.853.853 0 0 1 .25 2.81L2.81.25a.853.853 0 0 1 1.208 0Z"
      fillRule="evenodd"
      data-name="icon-/-24x24-/-ic24-alarm"
    />
  </svg>
);
